import React from 'react';
import { Modal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
// import MenuIcon from '@mui/icons-material/Menu';

import { useSelector, useDispatch } from 'react-redux';
import { selectInfoModal } from '../../store/ui/ui.selector';
import { changeInfoModal } from '../../store/ui/ui.slice';

import MarkdownToJsx from '../markdown-to-jsx/markdown-to-jsx.component';

// import dataAndTechText from '../../store/constants/componentTexts/dataAndTechText';
// import purposeText from '../../store/constants/componentTexts/purposeText';
// import howToUseText from '../../store/constants/componentTexts/howToUseText';
// import changelogText from '../../store/constants/componentTexts/changelogText';

// import { openReport } from '../../utilities/openReport';

import './info-modal.styles.scss';
// import HazardsMetricsTable from './hazards-metrics-table/hazards-metrics-table.component';
// import InternalLink from '../internal-link/internal-link.component';
// import ExternalLink from '../external-link/external-link.component';

// const HamburgerIcon = () => {
//   return (
//     <span style={{ position: 'relative', top: '6px' }}>
//       <MenuIcon />
//     </span>
//   );
// };

export default function InfoModal() {
  const dispatch = useDispatch();
  const infoModal = useSelector(selectInfoModal);

  // const handleClickInternalLink = (e, choice) => {
  //   e.preventDefault();
  //   dispatch(changeInfoModal(choice));
  // };

  const handleClose = () => {
    dispatch(changeInfoModal(null));
  };

  const mdDir = [process.env.PUBLIC_URL, 'markdown'].join('/');
  const content = <MarkdownToJsx path={`${mdDir}/${infoModal}.md`} />

  // let content;
  // if (infoModal === 'howToUseTool') {
  //   content = howToUseText(ExternalLink, HamburgerIcon);
  // } else if (infoModal === 'dataAndTech') {
  //   content = dataAndTechText(InternalLink, ExternalLink, openReport);
  // } else if (infoModal === 'purposeOfTool') {
  //   content = purposeText(InternalLink, ExternalLink, handleClickInternalLink);
  // } else if (infoModal === 'changelog') {
  //   content = changelogText();
  // } else {
  //   return <></>;
  // }

  // const text = content.sections.map((section, index) => {
  //   if (section.heading) {
  //     return (
  //       <React.Fragment key={index}>
  //         <div className='list-title'>{section.heading}</div>
  //         <ul>
  //           {section.paragraphs.map((paragraph, index) =>
  //             paragraph === 'hazardsAndMetricsTable' ? (
  //               <HazardsMetricsTable key={index} />
  //             ) : (
  //               <li key={index}>{paragraph}</li>
  //             )
  //           )}
  //         </ul>
  //       </React.Fragment>
  //     );
  //   } else {
  //     return (
  //       <React.Fragment key={index}>
  //         {section.paragraphs.map((paragraph, index) => (
  //           <p key={index}>{paragraph}</p>
  //         ))}
  //       </React.Fragment>
  //     );
  //   }
  // });

  return (
    <Modal open={infoModal !== null} onClose={handleClose}>
      <div className='info-modal-container'>
        <div className='info-modal-close'>
          <CloseIcon onClick={handleClose} />
        </div>

        {/* <h2 className='info-modal-title'>{content.title}</h2> */}
        {/* <div className='info-modal-description'>{text}</div> */}
        {content}
      </div>
    </Modal>
  );
}
